import HookFormTextField from 'reservations/form/components/HookFormTextField';

function NameFormField() {
  return <HookFormTextField name="name" label="Name" required />;
}

export default NameFormField;
